<template>
  <div class="parameter">
    <el-card shadow="never" class="aui-card--fill" header="账户预警设置">
      <div class="par_content">
        <div class="con_item" v-for="(item,index) in infoList" :key="index">
          <div class="top">
            <span>{{item.name}}</span>
            <el-button class="top_btn" type="primary" size="mini" plain @click="changeInfo(item)">修改</el-button>
            <span style="color: #2cb3a3;"  @click="visibleList(item.id)">变更记录</span>
          </div>
          <div class="middle">{{ item.code == 'THRESHOLD_VALUE' ? '￥'+Number(item.value).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : item.value+'h'  }}</div>
          <div class="bottom"> {{ item.code == 'THRESHOLD_VALUE' ? `当资方平台账户可用额度低于预警阈值时，资方将出现在「${fundRecharge ? fundRecharge : '需充值资方列表'}」页` : `当资方平台账户可用额度小于0.00的时长达到${item.value}h，系统将自动禁止资方账号放款`}}</div>
        </div>
        
      </div>
    </el-card>
    <el-dialog
      :title="'修改'+itemInfo.name"
      :visible.sync="dialogVisible"
      width="350px"
    >
      <el-input v-model="changeValue" placeholder="请输入"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx()">取 消</el-button>
        <el-button type="primary" @click="updateConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="this.dataForm.configId == '1813475461695868930' ? '预警变更记录' : '账号暂停变更记录' " :visible.sync="visible" width="60%" @close="closeList">
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
      >
        <el-table-column prop="createTime" label="时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="beforeChange" label="变更前" header-align="center" align="center">
          <template slot-scope="scope">
            {{ dataForm.configId == '1813475461695868930' ? '￥'+Number(scope.row.beforeChange).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : scope.row.beforeChange }}
          </template>
        </el-table-column>
        <el-table-column prop="afterChange" label="变更后" header-align="center" align="center">
          <template slot-scope="scope">
            {{ dataForm.configId == '1813475461695868930' ? '￥'+Number(scope.row.afterChange).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : scope.row.afterChange }}
          </template>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fundRecharge:'',
      dialogVisible: false,
      changeValue:'',
      visible: false,
      infoList: [],
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      dataListLoading: false,
      itemInfo:{},
      dataForm: {
        configId: ''
      }
    }
  },
  created() {
    this.getMenu()
    this.getInfo()
  },
  methods: {
    getMenu(){
      this.$http.get(`/sys/menu/nav`).then(res=>{
        let dataList = res.data.data
        const dataElement = dataList.find(element => element.id === '1587093161423261698');
        if (dataElement) {
          const resElement = dataElement.children.find(res => res.id === '1812774882266619905');
          if (resElement) {
            const rElement = resElement.children.find(r => r.id === '1812777146456776706');
            if (rElement) {
              this.fundRecharge = rElement.name || '';
            }
  }
}
      })
    },
    getInfo(){
      this.$http.get(`/system/config/list`).then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.infoList = res.data.data
      })
    },
    getDataList(id) {
      this.dataListLoading = true
      this.$http.get(`system/data/pageList/${this.page}/${this.limit}?configId=${id}`).then(res=>{
        if (res.data.code != 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.data.msg)
        }
        this.dataListLoading = false
        this.dataList = res.data.data.records
        this.total = res.data.data.total
      }).catch(() => {
          this.dataListLoading = false
        })
    },
    changeInfo(item){
      this.itemInfo = item
      this.dialogVisible = true
    },
    qx(){
      this.dialogVisible = false
      this.changeValue = ''
    },
    updateConfirm(){
      console.log(33,this.changeValue);
      
      if(!this.changeValue){
        return this.$message.error('请输入内容')
      }else if(isNaN(Number(this.changeValue))){
        return this.$message.error('请输入数字或"."')
      }
     this.$http.put('system/config/update',{
      id:this.itemInfo.id,
      name:this.itemInfo.name,
      code:this.itemInfo.code,
      value:this.changeValue
     }).then(res=>{
      if(res.data.code == 0){
        this.$message.success(res.data.msg)
        this.dialogVisible = false
        this.getInfo()
      }else{
        this.$message.error(res.data.msg)
      }
      
    })
    },
    visibleList(id){
      this.visible = true
      this.getDataList(id)
      this.dataForm = {
        configId: id
      }
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getDataList(this.dataForm.configId)
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getDataList(this.dataForm.configId)
    },
    closeList(){
      this.visible = false
      this.page = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.aui-card--fill{
  min-height: 85vh;
}
.par_content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .con_item{
    margin-bottom: 30px;
  }
  .top_btn{
    margin: 0 10px;
    padding: 3px 10px;
    font-size: 14px;
  }
  .middle{
    font-size: 30px;
    margin: 30px 0 10px;
  }
  .bottom{
    background-color:  rgba(245, 154, 35, 0.23);
    padding: 2px 16px;
    font-size: 12px;
  }

}
</style>